import { Component, inject, OnInit, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Header } from '../../shared/components/header/header';
import { Sidebar } from '../../shared/components/sidebar/sidebar';
import { CommonModule } from '@angular/common';
import { PageHeader } from '../../shared/components/page-header/page-header';
import { PageTitleService } from '../../shared/services';
import { BusinessService } from '../../services/business';
import { AuthService } from '../../services/auth';
import { OnboardingService } from '../../shared/services/onboarding.service';
import { OnboardingWelcomeService } from '../../shared/services/onboarding-welcome.service';
import { GracePeriodBannerComponent } from '../../shared/components/grace-period-banner/grace-period-banner.component';
import { WelcomeModal } from '../welcome-modal/welcome-modal';

@Component({
  selector: 'app-layout',
  imports: [
    CommonModule,
    Header,
    Sidebar,
    PageHeader,
    RouterOutlet,
    GracePeriodBannerComponent,
    WelcomeModal,
  ],
  templateUrl: './layout.html',
  styleUrl: './layout.css',
})
export class Layout implements OnInit {
  router = inject(Router);
  auth = inject(AuthService);
  private titleService = inject(PageTitleService);
  businessService = inject(BusinessService);
  private onboardingService = inject(OnboardingService);
  private onboardingWelcomeService = inject(OnboardingWelcomeService);
  // Mobile sidebar state - controls visibility on small screens
  sidebarToggle = signal(false);
  title = this.titleService.title;
  subtitle = this.titleService.subtitle;
  breadcrumbs = this.titleService.breadcrumbs;
  pagesBefore = this.titleService.pagesBefore;

  ngOnInit(): void {
    if (!this.auth.isLoggedIn()) {
      this.router.navigate(['/auth/signin']);
      return;
    }

    // Load auth data from storage first
    this.auth.loadFromStorage();

    // Use setTimeout to ensure token is processed before checking role
    setTimeout(() => {
      // Redirect sysadmin users to system admin panel
      if (this.auth.isSystemAdmin()) {
        const currentUrl = this.router.url;
        if (!currentUrl.includes('/system-admin')) {
          this.router.navigate(['/system-admin'], { replaceUrl: true });
          return;
        }
        // If already on system-admin, ensure modal is not shown
        this.businessService.needsBusinessInfo.set(false);
        return;
      }

      // Only check business info if not sysadmin
      this.businessService.checkAndPromptBusinessInfo();
      this.onboardingService.checkPrerequisites();
      this.onboardingWelcomeService.checkWelcomeStatus();
    }, 0);
  }

  closeSidebar() {
    this.sidebarToggle.set(false);
  }

  toggleSidebar() {
    this.sidebarToggle.update(v => !v);
  }

  onLogout() {
    this.router.navigate(['/auth/signin']);
  }
}
